$('.js--truncate').each((i, o) => {
    $(o).truncate({
        lines: o.dataset.truncate * 1 || 3,
        type: 'text',
        seeMoreLink: true,
        seeLessLink: true,
        seeMoreText: 'MORE',
        seeLessText: 'LESS',
        addClass: 'js--truncated',
        seeMoreIcon: null,
        seeLessIcon: null,
        seeMoreIconMobile: null,
    });
});
